import { useQuery } from "@tanstack/react-query";
import { GLOBAL_IMAGES } from "../../assets/asset";
import Header from "./Header";
import axiosInstance from "../../api/axiosInstance";
import { Loader2 } from "lucide-react";
import { resolveApiImageUrl } from "../../utils/imageUrl";

export default function Badges() {
  const badgesQuery = useQuery({
    queryKey: ["badges"],
    queryFn: () => axiosInstance.get("api/badgespage"),
    staleTime: 1 * 60 * 60 * 1000,
  });

  const imagesList = badgesQuery.isSuccess
    ? (Array.isArray(badgesQuery.data?.data?.Badgesassigned) ? badgesQuery.data.data.Badgesassigned : [])
    : [];

  return (
    <div
      className="h-screen flex flex-col items-center bg-blue-50 font-mali"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      role="main"
      aria-labelledby="years-dashboard-title"
    >
      <Header />
      <div className="container w-[95%] max-w-7xl ring-4 rounded-lg my-10 ring-white bg-white/30">
        <div className="bg-white/60 px-10 py-4">
          <p className="font-bold text-3xl">Earn Your Badges</p>
          <p className="font-medium text-xl mt-4">
            Badges for each milestone you achieve, setting new records or
            completing a perfect week.
          </p>
        </div>
        <div className="h-[22rem] overflow-auto">
          {badgesQuery.isPending ? (
            <div className="flex items-center justify-center h-full">
              <Loader2 className="h-12 w-12 animate-spin text-gray-600" />
            </div>
          ) : badgesQuery.isSuccess ? (
            <div className="h-full w-full flex flex-wrap gap-10 px-10 py-4">
              {imagesList.length ? (
                imagesList.map((item, index) => (
                  <img
                    key={index}
                    src={resolveApiImageUrl(item) || GLOBAL_IMAGES.badge}
                    className="h-36"
                    alt={`Badge ${index + 1}`}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = GLOBAL_IMAGES.badge;
                    }}
                  />
                ))
              ) : (
                <div className="flex items-center justify-center w-full text-gray-600 font-medium">
                  No badges earned yet. Complete lessons to earn badges.
                </div>
              )}
            </div>
          ) : (
            <div>Error</div>
          )}
        </div>
      </div>
    </div>
  );
}
